export default function rangesOverlap(firstStart, firstLength, secondStart, secondLength) {
  const firstEnd = firstStart + firstLength;
  const secondEnd = secondStart + secondLength;
  return Math.max(firstStart, secondStart) < Math.min(firstEnd, secondEnd);
}
